import { Icon } from "./Icon.js";
import { fmt } from "../lib/money.js";
import { monthsLabel, monthsToReach } from "../lib/projection.js";
import type { KidBundle } from "../api/me.js";

export interface GoalMiniProps {
  goal: KidBundle["goals"][number];
  kid: KidBundle["user"];
  account: KidBundle["account"];
  onClick?: () => void;
}

export function GoalMini({ goal, kid, account, onClick }: GoalMiniProps) {
  const pct = Math.min(100, (goal.savedCents / goal.targetCents) * 100);
  const monthlyIncome = account.allowanceCents + account.otherIncomeCents;
  const monthly =
    goal.allocType === "$" ? goal.allocValue : (monthlyIncome * goal.allocValue) / 100;
  const color = kid.color ?? "var(--brand)";
  const colorSoft = kid.colorSoft ?? "var(--brand-soft)";

  return (
    <div className="goal-card card" style={{ padding: 18 }} onClick={onClick}>
      <div className="row" style={{ marginBottom: 12 }}>
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 12,
            background: colorSoft,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color,
          }}
        >
          <Icon name={goal.icon} size={22} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontWeight: 500,
              fontSize: 14,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {goal.title}
          </div>
          <div className="soft" style={{ fontSize: 12 }}>
            {fmt(goal.savedCents, { showCents: false })} of{" "}
            {fmt(goal.targetCents, { showCents: false })}
          </div>
        </div>
      </div>
      <div className="progress">
        <div className="progress-fill" style={{ width: `${pct}%`, background: color }} />
      </div>
      <div className="row-between" style={{ marginTop: 8 }}>
        <div className="soft" style={{ fontSize: 12 }}>
          {pct.toFixed(0)}%
        </div>
        <div className="soft" style={{ fontSize: 12 }}>
          {monthsLabel(monthsToReach(goal, monthly))}
        </div>
      </div>
    </div>
  );
}
